/**
 * @generated SignedSource<<64c7c824324155143da4038458865bc3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GroupTableBody925BadPattern$data = {
  readonly aliases?: ReadonlyArray<string> | null | undefined;
  readonly fieldId: string | null | undefined;
  readonly jqlTerm: string;
  readonly " $fragmentSpreads": FragmentRefs<"FirstGroupRow756BadPattern">;
  readonly " $fragmentType": "GroupTableBody925BadPattern";
};
export type GroupTableBody925BadPattern$key = {
  readonly " $data"?: GroupTableBody925BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody925BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "GroupTableBody925BadPattern",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "jqlTerm"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "aliases"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "FirstGroupRow756BadPattern"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "1a315226786d5bd598d78da302bb62ee";

export default node;
